import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { COLORWAYS } from "@/lib/scroll";

export const Product = () => {
  const [active, setActive] = useState("pistacho");
  const current = COLORWAYS.find((c) => c.key === active);

  return (
    <section id="produit" data-testid="product-section" className="py-28 sm:py-40">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <Reveal><Overline>04 — Le produit</Overline></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display uppercase tracking-tight leading-[1.02] text-4xl sm:text-6xl mt-6">
                Une semelle<br />lestée.<br />Discrète.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-10 text-[#6E6A66] text-base sm:text-lg leading-relaxed max-w-md">
                SOLAMOVE est une semelle intérieure lestée, conçue comme un objet premium :
                le lestage est intégré directement dans la matière, invisible une fois dans la chaussure.
                Pensée pour un usage quotidien, elle est actuellement en cours de développement.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <ul className="mt-10 space-y-4">
                {["Semelle lestée", "Discrète dans la chaussure", "Usage quotidien", "Plusieurs coloris", "Conception en cours de développement"].map((t) => (
                  <li key={t} className="flex items-center gap-4 text-[#0D0D0D]">
                    <span className="h-px w-8 bg-[#A8B89A]" />
                    <span className="font-display uppercase tracking-wide text-sm">{t}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.4}>
              <p className="mt-14 font-mono-alt text-[10px] uppercase tracking-[0.3em] text-[#736F6E]">
                Courbes — Matière — Flexibilité — Finesse
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal>
              <div className="relative overflow-hidden border border-black/[0.06] bg-white p-6 sm:p-10">
                <AnimatePresence mode="wait">
                  <motion.img
                    key={active}
                    src={`/images/colorway-${active}.jpg`}
                    alt={`Semelle SOLAMOVE coloris ${current.name}`}
                    initial={{ opacity: 0, y: 50, scale: 1.04 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -30, scale: 0.98 }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    className="w-full aspect-[3/4] sm:aspect-[4/4.2] object-contain"
                  />
                </AnimatePresence>
                <p className="absolute top-6 left-6 font-mono-alt text-[10px] uppercase tracking-[0.25em] text-[#0D0D0D]/50 bg-white/60 backdrop-blur-sm px-3 py-2">
                  N°001 — Semelle lestée
                </p>
                <p className="absolute bottom-6 right-6 font-mono-alt text-[10px] uppercase tracking-[0.25em] text-[#0D0D0D]/50 bg-white/60 backdrop-blur-sm px-3 py-2">
                  Prototype en validation
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="mt-10">
                <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-[#736F6E] mb-5">4 coloris en étude</p>
                <div className="flex gap-4">
                  {COLORWAYS.map((c) => (
                    <button
                      key={c.key}
                      data-testid={`colorway-selector-${c.key}`}
                      onClick={() => setActive(c.key)}
                      aria-label={`Coloris ${c.name}`}
                      className={`h-12 w-12 rounded-full transition-transform duration-500 hover:scale-110 ${active === c.key ? "ring-1 ring-offset-4 ring-[#0D0D0D] ring-offset-white" : ""}`}
                      style={{ backgroundColor: c.hex, border: `1px solid ${c.border}` }}
                    />
                  ))}
                </div>
                <motion.p
                  key={active}
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  className="mt-5 font-display uppercase tracking-[0.2em] text-sm"
                >
                  {current.name} <span className="text-[#736F6E] normal-case tracking-normal font-sans">— {current.desc}</span>
                </motion.p>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1} className="mt-20">
          <div className="relative overflow-hidden">
            <img
              src="/images/colorways-lineup.jpg"
              alt="Les 4 coloris SOLAMOVE — CREMA, PISTACHO, MAQUILLAJE, NOIR"
              loading="lazy"
              className="w-full aspect-[16/10] sm:aspect-[16/7] object-cover hover:scale-[1.03] transition-transform duration-[1.8s] ease-out"
            />
          </div>
          <div className="flex justify-between mt-4 font-mono-alt text-[10px] uppercase tracking-[0.25em] text-[#736F6E]">
            <span>Crema — Pistacho — Maquillaje — Noir</span>
            <span>Visuels prototype</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
